/*

*/
import React from 'react'

const ShowPasswordEyeIcon = (props) => {
    const { name = "", size = "s", color = '#fff', className = "" } = props;

    return (
        <svg className={('icon', name) + " " + className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_897_2894)">
                <path d="M23.8209 11.181C22.9429 9.261 19.4999 3 11.9999 3C4.49987 3 1.05687 9.261 0.178871 11.181C0.0610095 11.4383 0 11.718 0 12.001C0 12.284 0.0610095 12.5637 0.178871 12.821C1.05687 14.739 4.49987 21 11.9999 21C19.4999 21 22.9429 14.739 23.8209 12.819C23.9385 12.562 23.9994 12.2827 23.9994 12C23.9994 11.7173 23.9385 11.438 23.8209 11.181ZM11.9999 18C10.8132 18 9.65315 17.6481 8.66645 16.9888C7.67976 16.3295 6.91072 15.3925 6.45659 14.2961C6.00247 13.1997 5.88365 11.9933 6.11516 10.8295C6.34667 9.66557 6.91812 8.59647 7.75723 7.75736C8.59635 6.91824 9.66544 6.3468 10.8293 6.11529C11.9932 5.88378 13.1996 6.0026 14.296 6.45672C15.3923 6.91085 16.3294 7.67988 16.9887 8.66658C17.648 9.65327 17.9999 10.8133 17.9999 12C17.9983 13.5908 17.3656 15.116 16.2408 16.2409C15.1159 17.3658 13.5907 17.9984 11.9999 18Z" fill="#7C808E" />
                <path d="M12.0002 15.9997C14.2094 15.9997 16.0002 14.2088 16.0002 11.9997C16.0002 9.79055 14.2094 7.99969 12.0002 7.99969C9.7911 7.99969 8.00024 9.79055 8.00024 11.9997C8.00024 14.2088 9.7911 15.9997 12.0002 15.9997Z" fill="#7C808E" />
            </g>
            <defs>
                <clipPath id="clip0_897_2894">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>

    )
};

export default ShowPasswordEyeIcon
